import { Link } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

const STEPS = [
  "Tenant rent due date is recorded",
  "Payment is tracked",
  "Tenant is reminded when required",
  "Rent receipt / payment record is maintained",
  "Owner is informed",
  "Service charges transparently shown",
  "Funds transferred via the appropriate banking channel, per your instructions and applicable regulations",
  "Monthly records maintained for the owner",
];

export const RentReporting = () => (
  <section className="bg-ivory py-24 sm:py-32" data-testid="rent-reporting-section">
    <div className="container-site grid gap-14 lg:grid-cols-2 lg:gap-20">
      <div className="lg:sticky lg:top-32 lg:self-start">
        <SectionHeading
          chapter="06"
          eyebrow="Rent Collection & Owner Remittance"
          title="Rent Collected. Records Maintained. Owner Updated."
          copy="Rent should arrive like clockwork — and you should never chase it across time zones. We track, remind, record and report."
        />
        <Reveal delay={0.15}>
          <div className="mt-8 flex gap-4 rounded-2xl border border-gold-500/30 bg-gold-300/15 p-6">
            <Info className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" />
            <p className="text-xs leading-relaxed text-navy-900/75 sm:text-sm">
              Tax, TDS, FEMA, repatriation and international remittance requirements can vary depending on
              your residency status, account type, property type and transaction. We can coordinate with your
              CA/bank or appropriate professional advisor where required. This website does not provide tax
              or legal advice.
            </p>
          </div>
          <Link to="/rent-collection" className="btn-navy mt-8" data-testid="rent-reporting-cta">
            How Rent Collection Works <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <Stagger className="space-y-3" gap={0.06}>
        {STEPS.map((s, i) => (
          <StaggerItem key={i}>
            <div className="flex items-center gap-5 rounded-2xl border border-navy-900/10 bg-white p-5" data-testid={`rent-step-${i + 1}`}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-900 font-display text-xs font-extrabold text-gold-400">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-sm font-medium leading-relaxed text-navy-900/85">{s}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
